import { Injectable, OnInit } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ProductsListState {

  public isSearchLoading = false;

  public isFullScreen = false;

  public zoom = 1;

}
